// extracted by mini-css-extract-plugin
export default {"subscriptionsContainer":"Subscriptions_subscriptionsContainer__LHpN+","loadingPlaceholder":"Subscriptions_loadingPlaceholder__bmg8h"};